<span class="badge-status badge-status-info badge-status-not-configured display-flex flex-align-center cursor"
      [customToolTip]="notification.muteValue$ | async"
      [showToolTip]="!disableTooltip"
      *ngIf="!showValue && (notification.isMute$ | async) || showValue && (notification.muteValue$ | async)">
  <mat-icon>notifications_paused</mat-icon>
  <span class="badge-text ml-5">{{ 'alerts.mute.mute' | translate }}</span>
  <span class="ml-5 badge-value" *ngIf="showValue">{{ notification.muteValue$ | async }}</span>
</span>
